import { render } from "./CompositionExample.vue?vue&type=template&id=125be35f&scoped=true&lang=true"
import script from "./CompositionExample.vue?vue&type=script&lang=js"
export * from "./CompositionExample.vue?vue&type=script&lang=js"

import "./CompositionExample.vue?vue&type=style&index=0&id=125be35f&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-125be35f"]])

export default __exports__